//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
//#reg

const GetReturnDetailByReturnId = (params: any) =>
    request({
        url: ApiURL.Query.getReturnDetailByReturnId,
        method: RequestType.GET,
        params: params,
    });
const GetReturnReason = (param?: any) => {
    const queryParams = [
        param?.shippingHasLostPackage ? `shippingHasLostPackage=${param.shippingHasLostPackage}` : '',
        param?.checkedCMIY ? `checkedCMIY=${param.checkedCMIY}` : '',
    ]
        .filter(Boolean)
        .join('&');
    return request({
        url: `${ApiURL.Query.getReturnReason}?${queryParams}`,
        method: RequestType.GET,
    });
};
const GetReturnRejectedReason = () =>
    request({
        url: ApiURL.Query.getReturnRejectedReason,
        method: RequestType.GET,
    });
const GetReturnStatus = () =>
    request({
        url: ApiURL.Query.getReturnStatus,
        method: RequestType.GET,
    });

const GetRejectedLabelDetails = (params: any) =>
    request({
        url: ApiURL.Query.getRejectedLabelDetails,
        method: RequestType.POST,
        params: params,
        responseType: 'blob',
        skipErrorModal: true,
    });
const GetDraftHistory = (params: any) =>
    request({
        url: ApiURL.Query.getDraftHistory,
        method: RequestType.GET,
        params: params,
    });
const GetReturnDetailByReturnIdForLostCargo = (data: any): Promise<any> =>
    request({
        url: `${ApiURL.Query.getReturnDetailByReturnIdForLostCargo}?ReturnId=${data.returnId}&CustomerId=${data.customerId}`,
        method: RequestType.GET,
        data,
    });
const GetReturnRejectReturnRejectCountryActiveListByRule = (params?: any) =>
    request({
        url: ApiURL.Query.getReturnRejectReturnRejectCountryActiveListByRule,
        method: RequestType.GET,
        params: params,
    });
const GetReturnRejectShipmentVisibleRule = (params?: any) =>
    request({
        url: ApiURL.Query.getReturnRejectShipmentVisibleRule,
        method: RequestType.GET,
        params: params,
    });

const GetShowResetButtonRule = () =>
    request({
        url: ApiURL.Query.getShowResetButtonRule,
        method: RequestType.GET,
    });

const GetBankConfigurationFromRule = (params: any) =>
    request({
        url: ApiURL.Query.getBankConfigurationFromRule,
        method: RequestType.GET,
        params: params,
    });

const GetPageRulesList = (params: any) =>
    request({
        url: ApiURL.Query.getPageRulesList,
        method: RequestType.GET,
        params: params,
    });

const CanStoreUserCreateRefund = (): Promise<any> =>
    request({
        url: ApiURL.Query.canStoreUserCreateRefund,
        method: RequestType.GET,
    });

const ReturnQuery = {
    GetReturnDetailByReturnId,
    GetReturnReason,
    GetReturnRejectedReason,
    GetReturnStatus,
    GetRejectedLabelDetails,
    GetReturnDetailByReturnIdForLostCargo,
    GetDraftHistory,
    GetReturnRejectReturnRejectCountryActiveListByRule,
    GetBankConfigurationFromRule,
    GetPageRulesList,
    GetReturnRejectShipmentVisibleRule,
    GetShowResetButtonRule,
    CanStoreUserCreateRefund,
};

export default ReturnQuery;
